import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { SaleStatisticTitle } from "../../../../Constants/Constants";
import { LI, UL } from "../../../../AbstractElements";
import ReactApexChart from "react-apexcharts";
import { OptionsRevenueOrder } from "../../../../Data/General/Widgets/General";

const SaleStatistic = () => {
  return (
    <Col sm="6">
      <Card>
        <DashboardCommonHeader title={SaleStatisticTitle} dropdownClass="dropdown-toggle" />
        <CardBody className="revenue-order">
          <UL className="d-flex align-item-center gap-2 simple-list flex-row">
            <LI><span className="bg-primary"> </span>Pending</LI>
            <LI><span className="bg-secondary"> </span>Completed</LI>
          </UL>
          <div id="general-revenue-order">
            <ReactApexChart options={OptionsRevenueOrder} series={OptionsRevenueOrder.series} type="line" height={274} />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SaleStatistic;
